import type {Scene} from '@babylonjs/core/scene';
import {CreatePlane} from '@babylonjs/core/Meshes/Builders/planeBuilder';
import {DynamicTexture} from '@babylonjs/core/Materials/Textures/dynamicTexture';
import {Texture} from '@babylonjs/core/Materials/Textures/texture';
import {StandardMaterial} from '@babylonjs/core/Materials/standardMaterial';
import {ParticleSystem} from '@babylonjs/core/Particles/particleSystem';
import {Color3,Color4} from '@babylonjs/core/Maths/math.color';
import {Vector3} from '@babylonjs/core/Maths/math.vector';
import type {ZoneState} from '@arena/shared';

const textures=new WeakMap<Scene,DynamicTexture>();
function puddle(scene:Scene):DynamicTexture{
  let texture=textures.get(scene);if(texture)return texture;
  texture=new DynamicTexture('kafka-water',{width:64,height:64},scene,false,Texture.NEAREST_SAMPLINGMODE);
  const g=texture.getContext();g.clearRect(0,0,64,64);g.fillStyle='#348daaba';
  for(let y=8;y<57;y+=3){const width=Math.sqrt(Math.max(0,24**2-(y-32)**2));g.fillRect(Math.round(32-width),y,Math.round(width*2),3);}
  g.fillStyle='#b2f1f3c0';for(const [x,y,w]of [[17,24,12],[35,39,14],[22,49,8],[40,20,7]])g.fillRect(x!,y!,w!,2);
  texture.hasAlpha=true;texture.update();textures.set(scene,texture);return texture;
}
export class WaterZoneView{
  private readonly mesh;private readonly material;private age=0;
  constructor(scene:Scene){
    this.mesh=CreatePlane('kafka-puddle',{size:1},scene);this.mesh.rotation.x=Math.PI/2;this.mesh.isPickable=false;
    this.material=new StandardMaterial('kafka-puddle',scene);this.material.diffuseTexture=puddle(scene);
    this.material.useAlphaFromDiffuseTexture=true;this.material.disableLighting=true;this.material.emissiveColor=Color3.White();this.material.backFaceCulling=false;
    this.mesh.material=this.material;
  }
  update(zone:ZoneState,dt:number):void{
    this.age+=dt;const wave=1+Math.sin(this.age*3)*.025;
    this.mesh.position.set(zone.x,zone.y+.035,zone.z);this.mesh.scaling.set(zone.radius*2.2*wave,zone.radius*2.2,1);
    this.material.alpha=Math.min(1,this.age*8,zone.ticks/15);
  }
  dispose():void{this.mesh.dispose();this.material.dispose();}
}

/** Brief water fans complement the bucket's drawn attack, including on a hit. */
export class KafkaWaterFx{
  private readonly texture:DynamicTexture;private bursts:{system:ParticleSystem;age:number}[]=[];
  private readonly scene:Scene;
  constructor(scene:Scene){
    this.scene=scene;
    this.texture=new DynamicTexture('kafka-droplet',{width:8,height:8},scene,false,Texture.NEAREST_SAMPLINGMODE);
    const g=this.texture.getContext();g.clearRect(0,0,8,8);g.fillStyle='#fff';g.fillRect(2,1,3,5);g.fillRect(1,3,5,3);this.texture.hasAlpha=true;this.texture.update();
  }
  splash(x:number,y:number,z:number,fx:number,fz:number,range:number):void{
    const system=new ParticleSystem('kafka-splash',32,this.scene);
    system.particleTexture=this.texture;system.emitter=new Vector3(x+fx*.55,y+.9,z+fz*.55);
    system.minEmitBox=system.maxEmitBox=Vector3.Zero();
    system.direction1=new Vector3(fx*range-fz*range*.6,1,fz*range+fx*range*.6);
    system.direction2=new Vector3(fx*range+fz*range*.6,2,fz*range-fx*range*.6);
    system.minEmitPower=1.5;system.maxEmitPower=2.2;system.gravity=new Vector3(0,-11,0);
    system.minLifeTime=.25;system.maxLifeTime=.55;system.minSize=.08;system.maxSize=.2;
    system.color1=new Color4(.3,.8,1,1);system.color2=new Color4(.75,.96,1,1);system.colorDead=new Color4(.25,.65,.8,0);
    system.emitRate=0;system.manualEmitCount=28;system.start();this.bursts.push({system,age:0});
  }
  update(dt:number):void{for(let i=this.bursts.length-1;i>=0;i--){const b=this.bursts[i]!;if((b.age+=dt)>.7){b.system.dispose(false);this.bursts.splice(i,1);}}}
  clear():void{for(const b of this.bursts)b.system.dispose(false);this.bursts=[];}
}
